import React from 'react';
import backgroundImage from '../background.webp';
import cardbackground from '../cardbackground.webp'; // Import card background image
import buttonImage from '../buttonimage.webp'; // Add this import
import { supabase } from '../supabaseClient';

export default function Validation({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'healingFormulasPage/validation',
                    animated_helper: 'no', // always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    const cardStyle = {
        width: '100%',
        maxWidth: '600px',
        height: 'auto', // Adjust height to fit text
        backgroundImage: `url(${cardbackground})`, // Use imported card background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: '2px solid black',
        borderRadius: '10px',
        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
        marginBottom: '20px', // Add space between cards
        padding: '20px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const textStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        lineHeight: '1.5',
        marginBottom: '16px',
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .validation-nav-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                        width: 100% !important;
                        justify-content: space-between !important;
                        margin: 0 !important;
                        padding: 0 2vw 0 2vw !important;
                    }
                    .validation-nav-row button {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 110px !important;
                        font-size: 15px !important;
                        padding: 10px 0 !important;
                        margin: 0 !important;
                    }
                }
                `}
            </style>
            <div
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px',
                }}
            >
                <h2
                    style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '36px',
                        fontWeight: 'bold',
                        color: '#4B5563',
                        textAlign: 'center',
                        marginTop: '16px',
                    }}
                >
                    Validation
                </h2>
                {/* Session Helper Cards Row */}
                <div
                    className="validation-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardbackground})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>• Looking for outside validation can trap us.</div>
                            <div>• We are capable of validating ourselves.</div>
                            <div>• Every perspective, feeling, or understanding we carry about an experience is valid to us.</div>
                            <div>• It does not have to make sense to others in order to be valid.</div>
                            <div>• Validating ourselves is like understanding ourselves.</div>
                            <div>• Even if we were wrong it is important to allow and understand that for ourselves.</div>
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardbackground})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>1. Are you able to offer yourself validation or do you look to others for it?</div>
                            <div>2. Have you ever retold the story of your experience to others for many years?</div>
                            <div>3. Do you feel upset if someone offers a differing view?</div>
                            <div>4. Can you feel your defensiveness soften when you validate yourself?Does your confidence lift?</div>
                            <div>5. Is there anything that you have invalidated yourself on?</div>
                            <div>6. Are you able to offer validation to others?</div>
                        </div>
                    </div>
                </div>
                <div style={cardStyle}>
                    <p style={textStyle}>
                        There is a stage in our upbringing where we look outside of ourselves to see if our caregiver approves of what we are doing. Later in life we can find ourselves still looking outside of ourselves for validation about what we are doing or how we feel.
                    </p>
                    <p style={textStyle}>
                        Some people have a subconscious priority of fitting in over being sovereign and authentic. When this is the case it can feel really natural to be retelling our experiences to others in order to gain approval. Sometimes when we have behaved in a way that hurts someone else, we have done that out of our own egoic coping structure that is trying to protect us. This same coping structure can then have us telling others our side of the story in order to gain validation for our actions. Whatever it is for us, we are doing it for a reason.  Often the reason is to protect ourselves.  Self preservation is a worthy cause and we can appreciate it for what it is. It is not wrong that we adopt ways of coping to keep ourselves safe.  There comes a time when we are ready to move on and when that time comes we are not doing it because we were wrong, we are doing it because we are ready to grow past it. 
                    </p>
                    <p style={textStyle}>
                        Beneath all this is the fact that we are individuals having unique experiences. Every single person on Earth has a different energy signature and therefore are here to experience life uniquely. It is therefore most appropriate for us to validate ourselves on our own experiences.
                    </p>
                    <p style={textStyle}>
                        The benefit of validating ourselves is that we get to know ourselves more, we stop feeding codependent patterns in our relationships, and we can complete the self-reflection process for ourselves. Being Authentic is the highest state we can be in. Validating ourselves opens us to that state of being. <br />  I have come to understand that the ego represents different concepts to different people. Part of being a healthy functioning human living in our culture is to have an ego that sort of organizes us into our lives. Keeps us going and gives us reasons for doing so. <br /> There can also be an aspect of our ego that is determined to keep us safe, relevant, happy, and likeable. When the ego is trying to protect us and we have had overwhelming or traumatic experiences, we can sometimes develop maladaptive coping mechanisms that cause us issues in the pursuit of avoiding something else. <br /> For this reason I am acknowledging the benefit of validating ourselves. This ego that wants to keep us safe is important and ultimately an act of self-love. We want to honor this for ourselves when we set out to make changes in our thoughts, feelings, and behaviors. Another way that this information can help us is to use it when we interact with other people. If we can accommodate and validate their ego in our communication style, we have a better chance of a successful exchange.

                    </p>
                </div>
                <div style={cardStyle}>
                    <p style={textStyle}>
                        I have looked at hundreds of Astrological Birth Charts to find that we are each dealing with a bit of all the energy. We each have the energy available to us in different ways. We each have different life experiences and we each have different reasons for being here on Earth.
                    </p>
                    <p style={textStyle}>
                        Even my identical Twin Sons have a different set of energy to work with in this lifetime. Because every person's perspective is unique, it stands to reason that is the reason you are here. Only you know exactly what you experienced, what you were thinking and feeling at the time, what you were protecting, the ways you have been hurt, the information you had at the time, the assumptions you made, the expectations you had, the preferences you had, and the outcome you wanted.
                    </p>
                    <p style={textStyle}>
                        These all paint the picture of your experience for you, and no one else can have that first-hand view like you do; even if you explain it to them, they watched it happen, or they had the same thing happen to them.
                    </p>
                </div>
                <div style={cardStyle}>
                    <p style={textStyle}>
                        Validation is so important to us that utilizing it or forgetting to include it can make or break a conversation. Any effective discussion between two people has both people with a desire or at least willingness to understand the other, even if they do not agree.
                    </p>
                    <p style={textStyle}>
                        Whenever we have to challenge what another is sharing, or offer a different or additional point of view, it is important to validate the other party's point of view before we try and get ourselves understood. If we skip the step where we offer our validation and they are not equipped to validate themselves, we will likely have them shut down to hearing us and communication will break down.
                    </p>
                    <p style={textStyle}>
                        This simple step is so effective for holding the space for the other party that it will produce completely different results. It can be as simple as repeating a summary of what they shared, verifying that you understood their point of view, or sharing that you agree but also have something else to consider.
                    </p>
                    <p style={textStyle}>
                        Feel free to experiment with this concept. It will be much more natural for you to offer others validation when you have practiced offering it to yourself.
                    </p>
                </div>
                {/* New Card with alchemy meme image */}
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <img
                        src="/images/alchemy%20meme.webp"
                        alt="Alchemy Meme"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginBottom: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain',
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    />
                </div>
                <div
                    className="validation-nav-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '16px',
                        marginBottom: '16px',
                        width: '100%',
                    }}
                >
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={goBack}
                    >
                        Back
                    </button>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={goHome}
                    >
                        Home
                    </button>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={handleSaveProgress}
                    >
                        Save
                    </button>
                </div>
            </div>
        </>
    );
}
